// extracted by mini-css-extract-plugin
module.exports = {"container":"KeywordSearchGroupForCompaniesWithJobs_container__2Dj7E","sending":"KeywordSearchGroupForCompaniesWithJobs_sending__3Ncv4"};